var _path, _path2, _circle, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImg403({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 480,
    height: 320,
    viewBox: "0 0 480 320",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M132.37 88V176.34H151.3V207.89H132.37V231.03H95.56V207.89H23V176.34L94.51 88H132.37ZM95.56 134.48L61.7 176.34H95.56V134.48Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M412.506 145.76C424.026 148.604 432.844 153.796 438.959 161.333C445.217 168.729 448.346 177.689 448.346 188.213C448.346 197.173 445.857 205.564 440.879 213.387C436.044 221.067 428.506 227.324 418.266 232.16C408.026 236.996 395.297 239.413 380.079 239.413C369.555 239.413 359.03 238.276 348.506 236C338.124 233.724 329.021 230.382 321.199 225.973L338.266 188.853C344.381 192.409 350.924 195.111 357.893 196.96C365.004 198.809 371.83 199.733 378.373 199.733C384.204 199.733 388.897 198.738 392.453 196.747C396.008 194.756 397.786 191.911 397.786 188.213C397.786 181.387 391.884 177.973 380.079 177.973H360.239V147.04L382.213 124.64H328.879V86.6666H440.239V117.6L412.506 145.76Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 240,
    cy: 160,
    r: 83,
    stroke: "#FF7B2E",
    strokeOpacity: 0.6,
    strokeWidth: 20
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M245.667 190.961H235.334V204.66H245.667V190.961Z",
    fill: "#FF7B2E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M245.667 180.687H235.333L225 114.45H256L245.667 180.687Z",
    fill: "#FF7B2E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg403);
export default __webpack_public_path__ + "static/media/img_403.3dca81efd476c837b3ab6bfb648e6258.svg";
export { ForwardRef as ReactComponent };